import React from 'react';
import ButtonContained from '@ntuctech/devex-tangram/Button/ButtonContained';
import Modal from '@ntuctech/devex-tangram/Modal';
import ModalActions from '@ntuctech/devex-tangram/ModalActions';
import ModalContent from '@ntuctech/devex-tangram/ModalContent';
import ModalTitle from '@ntuctech/devex-tangram/ModalTitle';
import Typography from '@ntuctech/devex-tangram/Typography';
import styled from 'styled-components';

const TypographySc = styled(Typography)`
  font-size: 1.125rem;
`;

const ModalTitleSc = styled(ModalTitle)`
  margin-bottom: 1rem;
`;

const ModalContentSc = styled(ModalContent)`
  margin-bottom: 2rem;
`;

const ButtonContainedSc = styled(ButtonContained)`
  background-color: #1445b8;
  color: #ffffff;
`;

const MyInfoMultipleAccModal = ({ verifiedEmail, errorTitle, errorMessage, setMyinfoConflict }) => {
  const handleOnclick = () => {
    localStorage.removeItem('myinfo_conflict');
    setMyinfoConflict(null);
  };

  if (verifiedEmail.length > 0) {
    const splitByNewline = errorMessage.split('\n');
    const firstPara = splitByNewline[0].split(verifiedEmail);
    const secondPara = splitByNewline[2];

    return (
      verifiedEmail && (
        <Modal open={errorTitle} data-testid="MyinfoMultipleAccModal">
          <ModalTitleSc>
            <Typography variant="h4">{errorTitle}</Typography>
          </ModalTitleSc>
          <ModalContentSc>
            <TypographySc>
              {`${firstPara[0]}`} <b>{verifiedEmail}</b> {`${firstPara[1]}`}
            </TypographySc>
          </ModalContentSc>
          <ModalContent>
            <TypographySc>{secondPara}</TypographySc>
          </ModalContent>
          <ModalActions>
            <ButtonContainedSc onClick={handleOnclick}>Close</ButtonContainedSc>
          </ModalActions>
        </Modal>
      )
    );
  } else {
    return (
      <Modal open={errorTitle} data-testid="MyinfoOtherError">
        <ModalTitleSc>
          <Typography variant="h4">{errorTitle}</Typography>
        </ModalTitleSc>
        <ModalContentSc>
          <TypographySc>{errorMessage}</TypographySc>
        </ModalContentSc>
        <ModalActions>
          <ButtonContainedSc onClick={handleOnclick}>Close</ButtonContainedSc>
        </ModalActions>
      </Modal>
    );
  }
};

export default MyInfoMultipleAccModal;
